import React from "react";

export const InfoModel = (props) => {
  return (
    <>
      <div
        id="popup-modal"
        tabIndex="-1"
        className="bg-12151D fixed inset-0 flex items-center justify-center z-50 w-full h-full bg-black bg-opacity-75 "
      >
        <div className="relative p-4 w-lg border-1 border-transparent rounded-xl">
          <div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
            <div className="flex items-center justify-between p-4 md:p-5 border-b bg-202531 rounded-t dark:border-gray-600 border-gray-200">
              <div>
                <h3 className="text-lg text-white font-bolder flex align-items-center">
                  {props.infoModalData.icon2}
                  {props.infoModalData.title}
                </h3>
              </div>
              <div>
                <button
                  type="button"
                  className="text-white"
                  data-modal-hide="popup-modal"
                  onClick={() => {
                    props.setOpenInfoModal(false);
                    props.setInfoModalData({});
                  }}
                >
                  <svg
                    className="w-3 h-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
            </div>

            <div className="p-4 md:p-5 text-left bg-181D29">
              {props.infoModalData?.maxBetDescription ? (
                <h3 className="mb-5 text-lg font-normal text-A5ABAD">
                  {props.infoModalData?.maxBetDescription}
                </h3>
              ) : (
                <div
                  className="mb-5 text-md font-normal text-A5ABAD"
                  dangerouslySetInnerHTML={{ __html: props.gameConfig?.rules }}
                />
              )}

              <div className="flex justify-center">
                <button
                  data-modal-hide="popup-modal"
                  type="button"
                  className="text-12151D font-b bg-yellow focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
                  onClick={()=>props.handleMaxBetEnabled()}
                >
                  {props.infoModalData.buttonName}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
